export const PASSKEY_ENROLL_OFFER_ID = 'passkey';

/**
 * The Dealer offers that have a wix-2025 redesign, gated by
 * `shouldActivateWix2025DealerOffersRedesign`.
 */
export const REDESIGNED_DEALER_OFFER_IDS: string[] = [
  'confirm-email',
  'confirm-details',
  'recovery-phone',
];
